export default "__VITE_ASSET__0oEnDK56__"